import { useState } from 'react';
import { Bell, BellOff, X, Users, TrendingUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const NotificationPopup = ({ 
  show, 
  memberCount = 50,
  newMembersCount = 0,
  onClose 
}) => {
  if (!show) return null;

  const displayCount = memberCount || 50;

  return (
    <div 
      data-testid="notification-popup"
      className="fixed top-4 left-4 z-[100] animate-fade-in"
      style={{ direction: 'rtl' }}
    >
      <div className="glass rounded-xl p-5 min-w-[320px] border border-cyan-500/30 neon-glow">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-cyan-500/20 flex items-center justify-center">
              <Bell size={18} className="text-cyan-400" />
            </div>
            <span className="font-semibold text-cyan-400">تنبيه جديد</span>
          </div>
          <button 
            onClick={onClose}
            className="text-neutral-500 hover:text-white transition-colors"
            data-testid="close-notification"
          >
            <X size={18} />
          </button>
        </div>

        {/* Content */}
        <div className="space-y-3">
          {/* Total Members */}
          <div className="bg-black/40 rounded-lg p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Users size={24} className="text-green-400" />
              <div>
                <p className="text-sm text-neutral-400">إجمالي الأعضاء المجمعين</p>
                <p className="text-2xl font-mono font-bold text-green-400">
                  {displayCount}
                </p>
              </div>
            </div>
          </div>

          {/* New Members (if any) */}
          {newMembersCount > 0 && (
            <div className="bg-cyan-500/10 rounded-lg p-3 flex items-center gap-3 border border-cyan-500/20">
              <TrendingUp size={20} className="text-cyan-400" />
              <div>
                <p className="text-sm text-cyan-300">
                  +{newMembersCount} عضو جديد
                </p>
              </div>
            </div>
          )}
        </div>

        {/* Progress indicator */}
        <div className="mt-4 h-1 bg-neutral-800 rounded-full overflow-hidden">
          <div 
            className="h-full bg-cyan-500 rounded-full"
            style={{ width: '100%', animation: 'shrink 5s linear forwards' }}
          />
        </div>
      </div>

      <style>{`
        @keyframes shrink {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </div>
  );
};

export const NotificationToggle = ({ soundEnabled, onToggle }) => {
  return (
    <Button
      data-testid="notification-toggle"
      variant="ghost"
      size="icon"
      onClick={onToggle}
      className={`relative ${soundEnabled ? 'text-cyan-400' : 'text-neutral-500'}`}
      title={soundEnabled ? 'صوت التنبيهات مفعّل' : 'صوت التنبيهات مكتوم'}
    >
      {soundEnabled ? (
        <Bell size={20} />
      ) : (
        <BellOff size={20} />
      )}
      {/* Status indicator */}
      <span 
        className={`absolute -top-1 -right-1 w-2 h-2 rounded-full ${
          soundEnabled ? 'bg-green-500 shadow-[0_0_6px_#00FF94]' : 'bg-neutral-600'
        }`}
      />
    </Button>
  );
};

export default NotificationPopup;
